import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H2, H1, BlueButton } from '../../StyledComponents';
import { navigate } from 'gatsby';
import chris from '../../../assets/v2/founders/chris.png';
import keith from '../../../assets/v2/founders/keith/keith@3x.png';
import shiv from '../../../assets/v2/founders/shiv/shiv@3x.png';
import yadhu from '../../../assets/v2/founders/yadhu/yadhu@3x.png';
import background from '../../../assets/v2/AboutUs/AboutBg.png';

const Section = styled(SectionParent)`
  background: #f9fdfe;
  padding-top: 5rem !important;
  padding-bottom: 7rem !important;
  @media (max-width: 520px) {
    padding-top: 4rem !important;
    padding-bottom: 2rem !important;
  }
`;
const SecondSection = styled.div`
  padding: 2rem 4rem;
  background: url(${background});
  background-color: #4051a3;
  background-size: cover;
  text-align: center;
  justify-content: center;
  height: fit-content;
  @media (max-width: 800px) {
    display: grid;
    padding: 1rem;
    background: #ebf8fd;
    background-color: #ebf8fd;
  }
`;
const SectionTitleMain = styled(H1)`
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-size: 36px !important;
  text-align: center;
  padding-bottom: 2rem;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 768px) {
    font-size: 20px !important;
  }
`;
const Grid = styled.div`
  display: grid;
  padding: 0 10rem;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 1100px) {
    padding: 0;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const GridItem = styled.div`
  justify-self: center;
  /* background: #1b224e; */
  padding: 2rem;
  padding-bottom: 0;
  min-height: 22rem;
  width: 100%;
  cursor: pointer;
  /* :hover {
    border-bottom: solid 3px #d72956;
  } */
  @media (max-width: 800px) {
    margin-bottom: 2rem;
    display: grid;
    justify-items: center;
    min-height: 18rem;
    cursor: default;
    :hover {
      border-bottom: none !important;
    }
  }
`;

const LeadName = styled.div`
  padding-top: 2rem;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3973e6;
  :hover {
    color: #0f49bd;
  }
`;

const LeadImg = styled.img`
  width: 180px;
  max-width: 180px;
  min-height: 180px;
  img {
    object-fit: contain !important;
  }
`;

const LeadRole = styled.div`
  padding-bottom: 0.5rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  text-align: center;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #63677a;
`;

const LeadExperience = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  color: #151828;
  text-align: left;
  font-size: 18px;
  /* padding: 0 12rem;
  margin-top: 2rem;
  padding-top: 0.5rem; */
  > p {
    text-align: justify;
  }
  img {
    margin-top: 1rem;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;
const LeadExperienceMob = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  color: #151828;
  text-align: justify;
  padding: 0 2rem;
  margin-bottom: 3rem;
  @media (min-width: 800px) {
    display: none;
  }
`;
const SectionTitle = styled(H1)`
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  text-align: center;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #151828;
`;

const SectionTopTitle = styled(H2)`
  color: #151828;
  text-align: center;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
`;
const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #626679;
  padding-top: 0.5rem;
  text-align: center;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 100%;
    text-align: center;
  }
`;
const TextContainer = styled.div`
  display: grid;
  justify-content: center;
  padding: 0 25rem;
  @media (max-width: 1100px) {
    padding: 0 10rem;
  }
  @media (max-width: 520px) {
    padding: 0;
  }
`;
const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  margin-top: 48px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;
const BlueButtonNew = styled(BlueButton)`
  border-radius: 23px;
`;

const ExperienceContainer = styled.div`
  border-radius: 4px;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.15);
  background-color: #ffffff;
  padding: 3rem 6.5rem;
  margin: 0rem 10rem;
  min-height: 14rem;
  display: grid;
  justify-items: center;
  @media (max-width: 1500px) {
    margin: 0rem 9rem 0 10rem;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;
export default class AboutUsSectionCareer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      mobile: false,
      selectedItem: 0,
      leadText:
        'Yadhu has over 25 years and 35 patents in embedded systems and security. His career includes roles as Chief Architect of Windows CE and Windows Phone. At Amazon, Yadhu designed back-end solutions for the FireOS and AWS before he owned Systems Engineering for Amazon Go. Today, Yadhu is our Chief Geek, CEO, and Co-Founder, and the visionary behind our mission to educate enterprises about DevOps for Smart Edge devices. ',
    };
    this.resize = this.resize.bind(this);
  }
  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  resize() {
    if (window.innerWidth <= 800) {
      this.setState({ mobile: true, selectedItem: -1 });
    } else {
      this.setState({ mobile: false, selectedItem: 0 });
    }
  }
  handleLead = (item: any) => {
    if (this.state.mobile === false || this.state.selectedItem !== -1) {
      switch (item) {
        case 0:
          this.setState({
            selectedItem: 0,
            leadText: this.props.messages?.AboutUsPageLeadershipCEODesc,
            // 'Yadhu has over 25 years and 35 patents in embedded systems and security. His 25-year career included roles as Chief Architect of the Windows CE and Windows Phone. At Amazon, Yadhu designed back-end solutions for the FireOS, and AWS before he owned Systems Engineering for Amazon Go. Today, Yadhu is our Chief Geek, CEO, and Co-Founder, and the visionary behind our mission to educate enterprises about DevOps for Smart Edge devices. ',
          });
          break;
        case 1:
          this.setState({
            selectedItem: 1,
            leadText: this.props.messages?.AboutUsPageLeadershipCOODesc,
            // 'Shiv makes things happen, both at Esper and for our customers. He knows Android inside-and-out after running Android partnerships for Huawei. Shiv strengthened his open source and device maker relationships after managing OEM partnerships at Cyanogen and Windows Phone device commercialization for Microsoft. Shiv is always ready to help businesses achieve Secure DevOps and deliver incredible customer experiences. ',
          });
          break;
        case 2:
          this.setState({
            selectedItem: 2,
            leadText: this.props.messages
              ?.AboutUsPageLeadershipVPCustomerSuccessDesc,
            // 'Chris helps our customers gain an agile advantage with Android DevOps across industries and use cases. Previously, he coached product, development, and innovation teams in executive roles at Microsoft, BNY Mellon, Eagle Investment Systems, and Caradigm. Chris has 25+ years’ experience as a champion and leader for the entire technical product and service lifecycle.',
          });
          break;
        case 3:
          this.setState({
            selectedItem: 3,
            leadText: this.props.messages?.AboutUsPageLeadershipVPMarketingDesc,
            // 'Keith is the geeky force-of-nature that drives Esper’s efforts to build a community of Android dedicated device developers and creators. He evangelizes Esper’s value to devs, Product Owners, and Chief Tech officers. Keith’s experience includes running product management for a dev tools startup that was sold to Symantec. Next, he worked at Microsoft with MSDN, CryptoAPI, Windows CE / Platform Builder, and Windows Mobile. Keith’s first programming language was BASIC on the TRS-80. He’s also shipped code for a PDP -11 at Siemens.',
          });
          break;
      }
    }
  };
  render() {
    return (
      <div>
        <SecondSection>
          <TextContainer>
            {' '}
            <SectionTopTitle>Our People</SectionTopTitle>
            <SectionTitle>Careers at Esper</SectionTitle>
            <SectionContent>
              We do Android, but we aren’t staffed by humanoid robots. Our
              people are a global team of Android developers, geeks, and agile
              thinkers. Collectively, we’re well on our way to changing the
              world’s enterprise Android ecosystem.
            </SectionContent>
          </TextContainer>
          <BlueButtonWrapper>
            <BlueButtonNew
              id="about_us__current_openings"
              onClick={() => navigate('/careers/')}
            >
              Culture {'&'} Current Openings
            </BlueButtonNew>
          </BlueButtonWrapper>
        </SecondSection>
      </div>
    );
  }
}
